export default __webpack_public_path__ + "f631b198cb045d83501c779640c04c50.svg";